import { DISTINCTCHECK } from "../../actions/portal/";

export default function(state = false, action){
  switch (action.type) {
    case DISTINCTCHECK:
    return action.payload;
    default:
  }

  return state;
}
